export default __webpack_public_path__ + "static/media/round_chart.1cdabb92.png";